import { combineReducers, configureStore, PreloadedState } from "@reduxjs/toolkit";
import { animalFiltersReducer } from "./animalFiltersSlice";
import { asyncJobReducer } from "./asyncJobSlice";
import { asyncImportJobReducer } from "./asyncImportJobSlice";
import { speciesReducer } from "./speciesSlice";
import { rowSelectionReducer } from "./rowSelectionSlice";
import medicineReducer from "medicines/state/reducer";

const rootReducer = combineReducers({
  animalFilters: animalFiltersReducer,
  asyncImportJob: asyncImportJobReducer,
  asyncJob: asyncJobReducer,
  rowSelection: rowSelectionReducer,
  species: speciesReducer,
  medicines: medicineReducer,
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
